import { useV2UpdateNotificationMutation } from "@generated";

// Fired whenever a notification's read state changes somewhere the acting
// component can't reach every other currently-mounted notification view
// (e.g. the bell dropdown's "Clear All" vs. the /notifications table, two
// unrelated components with differently-shaped, un-shareable query args).
// Listeners just refetch themselves with whatever args they're already on.
export const NOTIFICATIONS_CHANGED_EVENT = "notifications-changed";

// Shared by anywhere a notification's "View" link is rendered
const useMarkNotificationRead = () => {
  const [updateNotification] = useV2UpdateNotificationMutation();

  const handleView = async (
    e: React.MouseEvent,
    id: string | undefined,
    link: string
  ) => {
    e.preventDefault();

    if (!id) {
      window.location.href = link;
      return;
    }

    try {
      await updateNotification({
        id,
        body: {
          data: {
            id,
            type: "notifications",
            attributes: { "read-at": new Date().toISOString() },
          },
        },
      }).unwrap();
    } catch {
      // no-op — still navigate below
    } finally {
      window.location.href = link;
    }
  };

  return handleView;
};

export default useMarkNotificationRead;
